/**
 * 接口域名的管理
 * 参数在根目录对应的.env文件
 * 测试环境 .env.test
 * 生产环境 .env.production
 */
const env = import.meta.env;
export interface BaseUrl {
  api: string;
  cw: string;
  info: string;
  cwForm: string;
  cwForm2: string;
  gzb: string;
  invoice: string;
  netfile: string;
  signalrArr: string[];
  bs: string;
  AiServer: string;
  newServer: string;
  ThirdPartyTask: string;
}
export const baseUrl: BaseUrl = {
  api: env.VITE_APP_API,
  cw: env.VITE_APP_CW_TOKEN,
  info: env.VITE_APP_CW_INFO,
  cwForm: env.VITE_APP_CW_FORM,
  cwForm2: env.VITE_APP_CW_FORM_53112,
  gzb: env.VITE_APP_CW_GZB,
  invoice: env.VITE_APP_CW_INVOICE,
  signalrArr: env.VITE_APP_SIGNALR.split(","),
  netfile: env.VITE_APP_NETFILE,
  bs: env.VITE_APP_BS,
  AiServer: env.VITE_APP_AI_SERVER,
  newServer: env.VITE_APP_AI_NEW_SERVER,
  ThirdPartyTask: env.VITE_APP_AI_THIRDPARTYTASK,
};
console.log(baseUrl);

console.log(env);
